import React, { useState } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — input cu toggle vizibilitate parolă (eye icon).
 * Drop-in replacement pentru orice <Input type="password">.
 */
export function PasswordInput({ value, onChange, placeholder = "", className = "", autoFocus, name, "data-testid": testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <Input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        name={name}
        data-testid={testId}
        className="pr-10"
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-zinc-400 hover:text-zinc-700 transition-colors"
        tabIndex={-1}
        title={show ? "Ascunde parola" : "Afișează parola"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff size={16}/> : <Eye size={16}/>}
      </button>
    </div>
  );
}
